module.exports = __webpack_public_path__ + "static/js-7f130501681cb3d0129f266820c78b24.png";